// // src/Pages/AccGroupMaster.jsx
// import { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { Box, Typography, TextField, Button, CircularProgress, Paper, IconButton, Select, MenuItem, FormControl, InputLabel, Snackbar, Alert, Tooltip, Divider, Checkbox, FormControlLabel, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Chip, InputAdornment, } from "@mui/material";
// import { useAuth } from '../context/AuthContext';
// import { useParams, useNavigate } from "react-router-dom";
// import SearchIcon from "@mui/icons-material/Search";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import RefreshIcon from "@mui/icons-material/Refresh";

// // ─── Constants ───────────────────────────────────────────────────────────────
// const NATURE_OPTIONS = [
//   "Assets (Balance Sheet)",
//   "Liabilities (Balance Sheet)",
//   "Expense (Trading)",
//   "Expense (P & L)",
//   "Income (Trading)",
//   "Income (P & L)",
// ];

// const GRP_TYPE_MAP = {
//   "Assets (Balance Sheet)": "Assets",
//   "Liabilities (Balance Sheet)": "Liabilities (Balance Sheet)",
//   "Expense (Trading)": "Expense",
//   "Expense (P & L)": "Expense",
//   "Income (Trading)": "Income",
//   "Income (P & L)": "Income",
// };

// const DEFAULT_META = {
//   companyId: 1,
//   AppRegID: 1,
//   addUserId: 10,
//   branchId: 1,
//   fYear: getCurrentFYear(),
// };

// const EMPTY_FORM = {
//   GrpName: "",
//   IsPrimary: false,
//   SubGrpName: "",
//   NatureOfGroup: "",
//   GrpNameNo: "",
//   ShowDetails: true,
// };

// const VALIDATION_ERROR = "VALIDATION_ERROR";

// // ─── Shared sx helpers (mirrors ClientMaster style) ──────────────────────────
// const fieldSx = {
//   "& .MuiOutlinedInput-root": { height: 38, display: "flex", alignItems: "center" },
//   "& .MuiOutlinedInput-input": { fontSize: "0.875rem", padding: "0 12px" },
// };

// const requiredAsteriskStyle = {
//   "& .MuiFormLabel-asterisk": { color: "red" },
// };

// // ─── Component ───────────────────────────────────────────────────────────────
// export default function AccGroupMaster({ 
//   id, 
//   mode, 
//   onPopupCancel, 
//   connectionString, 
//   companyId: propsCompanyId 
// }) {
//   const { user, selectedCompany, loading } = useAuth();

//   // Handle both popup mode and route mode
//   const { id: routeId } = useParams();
//   const recordId = mode === "edit" ? id : routeId;

//   const navigate = useNavigate();

//   // Company info - adapted from TaxMaster pattern
//   const userId = user?.UserId || null;
//   const companyId = selectedCompany?.CompId;

//   const fYear = selectedCompany?.FYear || null;
//   const branchId = selectedCompany?.branchId || null;
//   const AppRegID = selectedCompany?.AppRegID || null;
//   console.log(`companyId: ${companyId} || userId: ${userId}`);
//   const path = connectionString;

//   // ── Form state ──────────────────────────────────────────────────────────────
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [formError, setFormError] = useState("");
//   const [errors, setErrors] = useState({});
//   const [editId, setEditId] = useState(null);
//   const [saving, setSaving] = useState(false);

//   // ── List state ──────────────────────────────────────────────────────────────
//   const [records, setRecords] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [selectedRowId, setSelectedRowId] = useState(null);
//   const [underGroupOptions, setUnderGroupOptions] = useState([]);

//   // ── Snackbar ────────────────────────────────────────────────────────────────
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//   const showSnack = (message, severity = "success") =>
//     setSnackbar({ open: true, message, severity });

//   // ── Fetch records ───────────────────────────────────────────────────────────
//   const fetchRecords = useCallback(
//     async (q = "") => {
//       setSearchLoading(true);
//       try {
//         const res = await axios.get(`${path}/api/AccUnderGroup/search`, {
//           params: {
//             mode: 'search',
//             companyId,
//             userId,
//             offset: 0,
//             limit: 50,
//             ...(q && { search: q })
//           }
//         });

//         setRecords(Array.isArray(res.data) ? res.data : res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//         showSnack("Failed to load records.", "error");
//       } finally {
//         setSearchLoading(false);
//       }
//     },
//     [path, companyId, userId]
//   );

//   // ── Fetch details on edit ────────────────────────────────────────────────────
//   useEffect(() => {
//     if (mode !== "edit" || !recordId) return;

//     const fetchDetails = async () => {
//       try {
//         const res = await axios.get(`${path}/api/AccUnderGroup/getDetails/${recordId}`);

//         const data = res.data;

//         setForm({
//           GrpName: data.GrpName || "",
//           IsPrimary: Number(data.PrimaryNo) === 1,
//           SubGrpName: data.SubGrpName || "",
//           NatureOfGroup: data.NatureOfGroup || "",
//           GrpNameNo: String(data.GrpNameNo || ""),
//           ShowDetails: data.ShowDetails ?? true,
//         });

//         setEditId(data.AccGrpID);

//       } catch (err) {
//         console.error("Failed to load group details", err);
//         showSnack("Failed to load data", "error");
//       }
//     };

//     fetchDetails();
//   }, [mode, recordId, path]);

//   // ── Fetch under groups ───────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchUnderGroups = async () => {
//       try {
//         const res = await axios.get(
//           `${path}/api/client-get-data/api/AccUnderGroup`,
//           {
//             params: { companyId }
//           }
//         );

//         // ✅ only primary groups
//         const primaryGroups = (res.data || []).filter(
//           g => Number(g.PrimaryNo) === 1
//         );

//         setUnderGroupOptions(primaryGroups);
//       } catch (err) {
//         console.error("Failed to load Under Groups", err);
//       }
//     };

//     if (companyId) fetchUnderGroups();
//   }, [companyId, path]);

//   // ── Fetch records on mount ───────────────────────────────────────────────────
//   useEffect(() => {
//     fetchRecords();
//   }, [fetchRecords]);

//   // ── Field helper ────────────────────────────────────────────────────────────
//   const setField = (field, value) => {
//     setForm((f) => ({ ...f, [field]: value }));
//     setErrors((e) => {
//       const n = { ...e };
//       delete n[field];
//       return n;
//     });
//     if (formError) setFormError("");
//   };

//   // ── Validate ────────────────────────────────────────────────────────────────
//   const validate = () => {
//     const e = {};
//     if (!form.GrpName.trim()) e.GrpName = "Group Name is required.";
//     if (!form.NatureOfGroup) e.NatureOfGroup = "Nature of Group is required.";
//     if (!form.GrpNameNo || isNaN(Number(form.GrpNameNo)))
//       e.GrpNameNo = "Valid Sch. No is required.";
//     if (!form.IsPrimary && !form.SubGrpName.trim())
//       e.SubGrpName = "Under Group is required when not primary.";
//     return e;
//   };

//   // ── Reset ───────────────────────────────────────────────────────────────────
//   const handleReset = () => {
//     setForm(EMPTY_FORM);
//     setErrors({});
//     setFormError("");
//     setEditId(null);
//     setSelectedRowId(null);

//     // Handle both popup and route modes
//     if (onPopupCancel) {
//       onPopupCancel();
//     } else {
//       navigate(-1);
//     }
//   };

//   // ── Submit ──────────────────────────────────────────────────────────────────
//   const handleSubmit = async (e) => {
//     e?.preventDefault?.();
//     const errs = validate();
//     if (Object.keys(errs).length) {
//       setErrors(errs);
//       setFormError("Please fix the highlighted fields.");
//       throw new Error(VALIDATION_ERROR);
//     }
//     setErrors({});
//     setFormError("");
//     setSaving(true);
//     try {
//       if (mode === "add" || mode === "comp") {
//         const payload = {
//           payload: {
//             GrpHead: form.GrpName.trim(),
//             PrimaryNo: form.IsPrimary ? 1 : 0,
//             GrpNameNo: Number(form.GrpNameNo),
//             GrpName: form.GrpName.trim(),
//             SubGrpName: form.IsPrimary ? "" : form.SubGrpName.trim(),
//             GrpType: GRP_TYPE_MAP[form.NatureOfGroup] || form.NatureOfGroup,
//             Select: 1,
//             ShowDetails: form.ShowDetails,
//             NatureOfGroup: form.NatureOfGroup,
//           },
//           companyId,
//           AppRegID,
//           addUserId: userId,
//           branchId,
//           fYear,
//         };
//         await axios.post(`${path}/api/AccUnderGroup/Insert`, payload);
//         showSnack("Group created successfully!");
//       } else {
//         const payload = {
//           GrpHead: form.GrpName.trim(),
//           PrimaryNo: form.IsPrimary ? 1 : 0,
//           GrpNameNo: Number(form.GrpNameNo),
//           GrpName: form.GrpName.trim(),
//           SubGrpName: form.IsPrimary ? "" : form.SubGrpName.trim(),
//           GrpType: GRP_TYPE_MAP[form.NatureOfGroup] || form.NatureOfGroup,
//           Select: 1,
//           ShowDetails: form.ShowDetails,
//           NatureOfGroup: form.NatureOfGroup,
//           companyId,
//           editUserId: userId,
//           branchId,
//           fYear,
//         };
//         await axios.put(`${path}/api/AccUnderGroup/Update/${editId}`, payload);
//         showSnack("Group updated successfully!");
//       }

//       // ✅ 600ms ke baad popup close / navigate (from TaxMaster pattern)
//       setTimeout(() => {
//         if (onPopupCancel) {
//           onPopupCancel();
//         } else {
//           navigate('/main/AccGroupDetails');
//         }
//       }, 600);
//     } catch (err) {
//       if (err.message === VALIDATION_ERROR) throw err;
//       if (err?.response?.status === 400) {
//         setFormError("Group already exists.");
//       } else {
//         setFormError(`Failed to ${mode === "add" || mode === "comp" ? "add" : "update"} group. Please try again.`);
//       }
//       showSnack(
//         err?.response?.data?.message ||
//         `Failed to ${mode === "add" || mode === "comp" ? "add" : "update"} group.`,
//         "error"
//       );
//       throw err;
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleFinalSubmit = async (e) => {
//     e?.preventDefault?.();
//     try {
//       await handleSubmit();
//     } catch {
//       // already handled
//     }
//   };

//   // ── Edit row ────────────────────────────────────────────────────────────────
//   const handleEditRow = (row) => {
//     setForm({
//       GrpName: row.GrpName || "",
//       IsPrimary: row.PrimaryNo === 1,
//       SubGrpName: row.SubGrpName || "",
//       NatureOfGroup: row.NatureOfGroup || "",
//       GrpNameNo: String(row.GrpNameNo || ""),
//       ShowDetails: row.ShowDetails ?? true,
//     });
//     setEditId(row.id ?? row.GrpNameNo);
//     setSelectedRowId(row.id ?? row.GrpNameNo);
//     setErrors({});
//     setFormError("");
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   // ── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* ══════════════ FORM CARD ══════════════ */}
//       <Paper elevation={3} sx={{ p: 3, pt: 1, mt: 1, mx: "auto", maxWidth: 900 }}>
//         <Box
//           component="form"
//           noValidate
//           onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
//           onSubmit={handleFinalSubmit}
//         >
//           {/* Header */}
//           <Box sx={{ position: "relative" }}>
//             <Typography
//               variant="h5"
//               sx={{
//                 textAlign: "center",
//                 fontSize: { xs: "1.25rem", sm: "1.5rem" },
//                 fontWeight: 600,
//                 mb: 1,
//               }}
//             >
//               {mode === "add" || mode === "comp" ? "Add Account Group" : "Edit Account Group"}
//             </Typography>
//           </Box>

//           <Divider sx={{ mb: 2 }} />

//           {/* Two-column layout — mirrors ClientMaster */}
//           <Box display="flex" flexWrap="wrap" gap={2}>

//             {/* ── LEFT COLUMN ── */}
//             <Box
//               sx={{
//                 flex: { xs: "100%", md: "48%" },
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 2,
//               }}
//             >
//               {/* Group Name */}
//               <TextField
//                 label="Group Name"
//                 fullWidth
//                 size="small"
//                 required
//                 value={form.GrpName}
//                 error={Boolean(errors.GrpName)}
//                 helperText={errors.GrpName}
//                 onChange={(e) => setField("GrpName", e.target.value.toUpperCase())}
//                 inputProps={{ maxLength: 100 }}
//                 InputLabelProps={{ sx: requiredAsteriskStyle }}
//                 sx={fieldSx}
//               />

//               {/* Is Primary */}
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={form.IsPrimary}
//                     onChange={(e) => {
//                       setField("IsPrimary", e.target.checked);
//                       if (e.target.checked) setField("SubGrpName", "");
//                     }}
//                     size="small"
//                   />
//                 }
//                 label={
//                   <Typography sx={{ fontSize: "0.875rem" }}>Is Primary ?</Typography>
//                 }
//                 sx={{ ml: 0, mt: -1 }}
//               />

//               {/* Under Group */}
//               <FormControl
//                 fullWidth
//                 size="small"
//                 required={!form.IsPrimary}
//                 disabled={form.IsPrimary}
//                 error={Boolean(errors.SubGrpName)}
//               >
//                 <InputLabel sx={requiredAsteriskStyle}>Under Group</InputLabel>

//                 <Select
//                   value={form.SubGrpName}
//                   onChange={(e) => setField("SubGrpName", e.target.value)}
//                   label="Under Group"
//                   sx={{ height: 38, fontSize: "0.875rem" }}
//                 >
//                   <MenuItem value="" disabled>
//                     Select Under Group
//                   </MenuItem>

//                   {underGroupOptions.map((grp) => (
//                     <MenuItem key={grp.AccGrpID} value={grp.GrpName}>
//                       {grp.GrpName}
//                     </MenuItem>
//                   ))}
//                 </Select>

//                 {errors.SubGrpName && (
//                   <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
//                     {errors.SubGrpName}
//                   </Typography>
//                 )}
//               </FormControl>

//               {/* Nature of Group */}
//               <FormControl
//                 fullWidth
//                 size="small"
//                 error={Boolean(errors.NatureOfGroup)}
//                 required
//               >
//                 <InputLabel sx={requiredAsteriskStyle}>Nature of Group</InputLabel>
//                 <Select
//                   label="Nature of Group"
//                   value={form.NatureOfGroup}
//                   onChange={(e) => setField("NatureOfGroup", e.target.value)}
//                   sx={{ height: 38, fontSize: "0.875rem" }}
//                 >
//                   <MenuItem value="" disabled>
//                     — Select —
//                   </MenuItem>
//                   {NATURE_OPTIONS.map((o) => (
//                     <MenuItem key={o} value={o} sx={{ fontSize: "0.875rem" }}>
//                       {o}
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 {errors.NatureOfGroup && (
//                   <Typography
//                     variant="caption"
//                     color="error"
//                     sx={{ mt: 0.5, ml: 1.5 }}
//                   >
//                     {errors.NatureOfGroup}
//                   </Typography>
//                 )}
//               </FormControl>
//             </Box>

//             {/* ── RIGHT COLUMN ── */}
//             <Box
//               sx={{
//                 flex: { xs: "100%", md: "48%" },
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 2,
//               }}
//             >
//               {/* Sch. No + Show in Details */}
//               <Box display="flex" gap={1} alignItems="flex-start">
//                 <TextField
//                   label="Sch. No."
//                   size="small"
//                   required
//                   type="number"
//                   value={form.GrpNameNo}
//                   error={Boolean(errors.GrpNameNo)}
//                   helperText={errors.GrpNameNo}
//                   onChange={(e) => setField("GrpNameNo", e.target.value)}
//                   InputLabelProps={{ sx: requiredAsteriskStyle }}
//                   sx={{ ...fieldSx, flex: 1 }}
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={form.ShowDetails}
//                       onChange={(e) => setField("ShowDetails", e.target.checked)}
//                       size="small"
//                     />
//                   }
//                   label={
//                     <Typography sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                       Show in Details ?
//                     </Typography>
//                   }
//                   sx={{ ml: 0, flex: 1.2, alignSelf: "center" }}
//                 />
//               </Box>

//               {/* Derived read-only: Group Type */}
//               <TextField
//                 label="Group Type (auto)"
//                 fullWidth
//                 size="small"
//                 disabled
//                 value={GRP_TYPE_MAP[form.NatureOfGroup] || ""}
//                 sx={fieldSx}
//               />
//             </Box>
//           </Box>

//           {/* Form Error */}
//           {formError && (
//             <Typography color="error" align="center" sx={{ mt: 2 }}>
//               {formError}
//             </Typography>
//           )}

//           {/* Buttons */}
//           <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               sx={{ minWidth: 120, height: 38 }}
//               type="submit"
//               disabled={saving}
//               startIcon={
//                 saving ? <CircularProgress size={16} color="inherit" /> : null
//               }
//             >
//               {mode === "add" || mode === "comp" ? "Submit" : "Update"}
//             </Button>
//             <Button
//               variant="contained"
//               color="error"
//               sx={{ minWidth: 120, height: 38 }}
//               onClick={handleReset}
//               disabled={saving}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </Box>
//       </Paper>


//       {/* Global Snackbar — identical to ClientMaster */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={1500}
//         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// }




import { gradients } from '../utils/theme';
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Box, Typography, TextField, Button, CircularProgress, Paper, IconButton, Select, MenuItem, FormControl, InputLabel, Snackbar, Alert, Tooltip, Divider, Checkbox, FormControlLabel, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Chip, InputAdornment, } from "@mui/material";
import { useAuth } from '../context/AuthContext';
import { useParams, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getCurrentFYear } from '../utils/financialYear';

// ─── Constants ───────────────────────────────────────────────────────────────
const NATURE_OPTIONS = [
  "LIABILITIES",
  "INCOME (TRADING)",
  "ASSETS",
  "EXPENSE (P & L)",
  "INCOME (P & L)",
  "EXPENSE (TRADING)",
];

// GrpType values are unchanged — only the Nature of Group keys were renamed.
const GRP_TYPE_MAP = {
  "ASSETS": "Assets",
  "LIABILITIES": "Liabilities (Balance Sheet)",
  "EXPENSE (TRADING)": "Expense",
  "EXPENSE (P & L)": "Expense",
  "INCOME (TRADING)": "Income",
  "INCOME (P & L)": "Income",
};

const DEFAULT_META = {
  companyId: 1,
  AppRegID: 1,
  addUserId: 10,
  branchId: 1,
  fYear: getCurrentFYear(),
};

const EMPTY_FORM = {
  GrpName: "",
  IsPrimary: false,
  SubGrpName: "",
  NatureOfGroup: "",
  GrpNameNo: "",
  ShowDetails: true,
};

const VALIDATION_ERROR = "VALIDATION_ERROR";

// ─── Shared sx helpers (mirrors ClientMaster style) ──────────────────────────
const fieldSx = {
  "& .MuiOutlinedInput-root": { height: 38, display: "flex", alignItems: "center" },
  "& .MuiOutlinedInput-input": { fontSize: "0.875rem", padding: "0 12px" },
};

const requiredAsteriskStyle = {
  "& .MuiFormLabel-asterisk": { color: "red" },
};

// ─── Component ───────────────────────────────────────────────────────────────
export default function AccGrpMaster({
  id,
  mode,
  onPopupCancel,
  connectionString,
  companyId
}) {
  const { user, selectedCompany, loading } = useAuth();

  // Handle both popup mode and route mode
  const { id: routeId } = useParams();
  const recordId = mode === "edit" ? id : routeId;

  const navigate = useNavigate();

  // Company info - adapted from TaxMaster pattern
  const userId = user?.UserId || null;
  // const companyId = selectedCompany?.CompId;

  const fYear = getCurrentFYear();
  const branchId = selectedCompany?.branchId || null;
  const AppRegID = selectedCompany?.AppRegID || null;
  console.log(`companyId: ${companyId} || userId: ${userId}`);
  const path = connectionString;

  // ── Form state ──────────────────────────────────────────────────────────────
  const [form, setForm] = useState(EMPTY_FORM);
  const [formError, setFormError] = useState("");
  const [errors, setErrors] = useState({});
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  // ── List state ──────────────────────────────────────────────────────────────
  const [records, setRecords] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [underGroupOptions, setUnderGroupOptions] = useState([]);

  // ── Snackbar ────────────────────────────────────────────────────────────────
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnack = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  // ── Fetch records ───────────────────────────────────────────────────────────
  const fetchRecords = useCallback(
    async (q = "") => {
      setSearchLoading(true);
      try {
        const res = await axios.get(`${path}/api/AccUnderGroup/search`, {
          params: {
            mode: 'search',
            companyId,
            userId,
            offset: 0,
            limit: 50,
            ...(q && { search: q })
          }
        });

        setRecords(Array.isArray(res.data) ? res.data : res.data?.data || []);
      } catch (err) {
        console.error(err);
        showSnack("Failed to load records.", "error");
      } finally {
        setSearchLoading(false);
      }
    },
    [path, companyId, userId]
  );

  // ── Fetch details on edit ────────────────────────────────────────────────────
  useEffect(() => {
    if (mode !== "edit" || !recordId) return;

    const fetchDetails = async () => {
      try {
        const res = await axios.get(`${path}/api/AccUnderGroup/getDetails/${recordId}`);

        const data = res.data;
        console.log(data);

        setForm({
          GrpName: data.SubGrpName || "",
          IsPrimary: Number(data.IsPrimary) === 1,
          SubGrpName: data.GrpName || "",
          NatureOfGroup: data.NatureOfGroup || "",
          GrpNameNo: String(data.GrpNameNo || ""),
          ShowDetails: data.ShowDetails ?? true,
        });

        setEditId(data.AccGrpID);

      } catch (err) {
        console.error("Failed to load group details", err);
        showSnack("Failed to load data", "error");
      }
    };

    fetchDetails();
  }, [mode, recordId, path]);

  // ── Fetch under groups ───────────────────────────────────────────────────────
  useEffect(() => {
    const fetchUnderGroups = async () => {
      try {
        const res = await axios.get(`${path}/api/client-get-data/api/AccUnderGroup`, { params: { companyId } });

        // ✅ Only show PRIMARY groups (IsPrimary = 1)
        const primaryGroups = (res.data || []).filter(g => Number(g.IsPrimary) === 1);

        setUnderGroupOptions(primaryGroups);
      } catch (err) {
        console.error("Failed to load Under Groups", err);
      }
    };

    if (companyId) fetchUnderGroups();
  }, [companyId, path]);

  // ── Fetch records on mount ───────────────────────────────────────────────────
  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  // ── Field helper ────────────────────────────────────────────────────────────
  const setField = (field, value) => {
    setForm((f) => ({ ...f, [field]: value }));
    setErrors((e) => {
      const n = { ...e };
      delete n[field];
      return n;
    });
    if (formError) setFormError("");
  };

  // ── Validate ────────────────────────────────────────────────────────────────
  const validate = () => {
    const e = {};
    if (!form.GrpName.trim()) e.GrpName = "Group Name is required.";
    if (!form.NatureOfGroup) e.NatureOfGroup = "Nature of Group is required.";
    if (!form.GrpNameNo || isNaN(Number(form.GrpNameNo)))
      e.GrpNameNo = "Valid Sch. No is required.";
    if (!form.IsPrimary && !form.SubGrpName.trim())
      e.SubGrpName = "Under Group is required when not primary.";
    return e;
  };

  // ── Reset ───────────────────────────────────────────────────────────────────
  const handleReset = () => {
    setForm(EMPTY_FORM);
    setErrors({});
    setFormError("");
    setEditId(null);
    setSelectedRowId(null);

    // Handle both popup and route modes
    if (onPopupCancel) {
      onPopupCancel();
    } else {
      navigate(-1);
    }
  };

  // ── Submit ──────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      setFormError("Please fix the highlighted fields.");
      throw new Error(VALIDATION_ERROR);
    }
    setErrors({});
    setFormError("");
    setSaving(true);
    try {
      if (mode === "add" || mode === "comp") {
        const payload = {
          payload: {
            GrpHead: form.GrpName.trim(),
            IsPrimary: form.IsPrimary ? 1 : 0,
            GrpNameNo: Number(form.GrpNameNo),
            GrpName: form.IsPrimary
              ? form.GrpName.trim()
              : form.SubGrpName.trim(),

            SubGrpName: form.IsPrimary
              ? form.GrpName.trim()
              : form.GrpName.trim(),
            GrpType: GRP_TYPE_MAP[form.NatureOfGroup] || form.NatureOfGroup,
            Select: 1,
            ShowDetails: form.ShowDetails,
            NatureOfGroup: form.NatureOfGroup,
          },
          companyId,
          AppRegID,
          addUserId: userId,
          branchId,
          fYear,
        };
        console.log(payload)
        await axios.post(`${path}/api/AccUnderGroup/Insert`, payload);
        showSnack("Group created successfully!");
      } else {
        const payload = {
          GrpHead: form.GrpName.trim(),
          IsPrimary: form.IsPrimary ? 1 : 0,
          GrpNameNo: Number(form.GrpNameNo),
          GrpName: form.IsPrimary
            ? form.GrpName.trim()
            : form.SubGrpName.trim(),

          SubGrpName: form.IsPrimary
            ? form.GrpName.trim()
            : form.GrpName.trim(),
          GrpType: GRP_TYPE_MAP[form.NatureOfGroup] || form.NatureOfGroup,
          Select: 1,
          ShowDetails: form.ShowDetails,
          NatureOfGroup: form.NatureOfGroup,
          companyId,
          editUserId: userId,
          branchId,
          fYear,
        };
        await axios.put(`${path}/api/AccUnderGroup/Update/${editId}`, payload);
        showSnack("Group updated successfully!");
      }

      // ✅ 600ms ke baad popup close / navigate (from TaxMaster pattern)
      setTimeout(() => {
        if (onPopupCancel) {
          onPopupCancel();
        } else {
          navigate('/main/AccGroupDetails');
        }
      }, 600);
    } catch (err) {
      if (err.message === VALIDATION_ERROR) throw err;
      if (err?.response?.status === 400) {
        setFormError("Group already exists.");
      } else {
        setFormError(`Failed to ${mode === "add" || mode === "comp" ? "add" : "update"} group. Please try again.`);
      }
      showSnack(
        err?.response?.data?.message ||
        `Failed to ${mode === "add" || mode === "comp" ? "add" : "update"} group.`,
        "error"
      );
      throw err;
    } finally {
      setSaving(false);
    }
  };

  const handleFinalSubmit = async (e) => {
    e?.preventDefault?.();
    try {
      await handleSubmit();
    } catch {
      // already handled
    }
  };

  // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
  // Attached to document in the capture phase so it fires regardless of which
  // field/dropdown currently has focus, including MUI popper/portal content.
  // Uses e.code (physical key position) instead of e.key so this also works on
  // macOS, where Option+letter often produces an accented/dead-key character
  // via e.key (e.g. Option+C → "ç") instead of the plain letter.
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      if (!e.altKey) return;

      if (e.code === "KeyS") {
        e.preventDefault();
        if (!saving) {
          handleFinalSubmit(e);
        }
      } else if (e.code === "KeyC") {
        e.preventDefault();
        handleReset();
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown, true);
    return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
  });

  // ── Edit row ────────────────────────────────────────────────────────────────
  const handleEditRow = (row) => {
    setForm({
      GrpName: row.GrpName || "",
      IsPrimary: row.IsPrimary === 1,
      SubGrpName: row.SubGrpName || "",
      NatureOfGroup: row.NatureOfGroup || "",
      GrpNameNo: String(row.GrpNameNo || ""),
      ShowDetails: row.ShowDetails ?? true,
    });
    setEditId(row.id ?? row.GrpNameNo);
    setSelectedRowId(row.id ?? row.GrpNameNo);
    setErrors({});
    setFormError("");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <>
      <Box sx={{ height: 4, background: gradients.primaryRow }} />
      <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
        <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
          {mode === "add" || mode === "comp" ? "Add Account Group" : "Edit Account Group"}
        </Typography>
      </Box>
      <Divider />
      <Box
        component="form"
        noValidate
        onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
        onSubmit={handleFinalSubmit}
      >
        <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>

          {/* Two-column layout — mirrors ClientMaster */}
          <Box display="flex" flexWrap="wrap" gap={2}>

            {/* ── LEFT COLUMN ── */}
            <Box
              sx={{
                flex: { xs: "100%", md: "48%" },
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* Group Name */}
              <TextField
                label="Group Name"
                fullWidth
                size="small"
                required
                value={form.GrpName}
                error={Boolean(errors.GrpName)}
                helperText={errors.GrpName}
                onChange={(e) => setField("GrpName", e.target.value.toUpperCase())}
                inputProps={{ maxLength: 100 }}
                InputLabelProps={{ sx: requiredAsteriskStyle }}
                sx={fieldSx}
              />

              {/* Is Primary */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.IsPrimary}
                    onChange={(e) => {
                      setField("IsPrimary", e.target.checked);
                      if (e.target.checked) setField("SubGrpName", "");
                    }}
                    size="small"
                  />
                }
                label={
                  <Typography sx={{ fontSize: "0.875rem" }}>Is Primary ?</Typography>
                }
                sx={{ ml: 0, mt: -1 }}
              />

              {/* Under Group */}
              <FormControl
                fullWidth
                size="small"
                required={!form.IsPrimary}
                disabled={form.IsPrimary}
                error={Boolean(errors.SubGrpName)}
              >
                <InputLabel sx={requiredAsteriskStyle}>Under Group</InputLabel>

                <Select
                  value={form.SubGrpName}
                  onChange={(e) => setField("SubGrpName", e.target.value)}
                  label="Under Group"
                  sx={{ height: 38, fontSize: "0.875rem" }}
                >
                  <MenuItem value="" disabled>
                    Select Under Group
                  </MenuItem>

                  {underGroupOptions.map((grp) => (
                    <MenuItem key={grp.AccGrpID} value={grp.GrpName}>
                      {grp.GrpName}
                    </MenuItem>
                  ))}
                </Select>

                {errors.SubGrpName && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    {errors.SubGrpName}
                  </Typography>
                )}
              </FormControl>

              {/* Nature of Group */}
              <FormControl
                fullWidth
                size="small"
                error={Boolean(errors.NatureOfGroup)}
                required
              >
                <InputLabel sx={requiredAsteriskStyle}>Nature of Group</InputLabel>
                <Select
                  label="Nature of Group"
                  value={form.NatureOfGroup}
                  onChange={(e) => setField("NatureOfGroup", e.target.value)}
                  sx={{ height: 38, fontSize: "0.875rem" }}
                >
                  <MenuItem value="" disabled>
                    — Select —
                  </MenuItem>
                  {NATURE_OPTIONS.map((o) => (
                    <MenuItem key={o} value={o} sx={{ fontSize: "0.875rem" }}>
                      {o}
                    </MenuItem>
                  ))}
                </Select>
                {errors.NatureOfGroup && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 0.5, ml: 1.5 }}
                  >
                    {errors.NatureOfGroup}
                  </Typography>
                )}
              </FormControl>
            </Box>

            {/* ── RIGHT COLUMN ── */}
            <Box
              sx={{
                flex: { xs: "100%", md: "48%" },
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* Sch. No + Show in Details */}
              <Box display="flex" gap={1} alignItems="flex-start">
                <TextField
                  label="Sch. No."
                  size="small"
                  required
                  type="number"
                  value={form.GrpNameNo}
                  error={Boolean(errors.GrpNameNo)}
                  helperText={errors.GrpNameNo}
                  onChange={(e) => setField("GrpNameNo", e.target.value)}
                  InputLabelProps={{ sx: requiredAsteriskStyle }}
                  sx={{ ...fieldSx, flex: 1 }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.ShowDetails}
                      onChange={(e) => setField("ShowDetails", e.target.checked)}
                      size="small"
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
                      Show in Details ?
                    </Typography>
                  }
                  sx={{ ml: 0, flex: 1.2, alignSelf: "center" }}
                />
              </Box>

              {/* Derived read-only: Group Type */}
              <TextField
                label="Group Type (auto)"
                fullWidth
                size="small"
                disabled
                value={GRP_TYPE_MAP[form.NatureOfGroup] || ""}
                sx={fieldSx}
              />
            </Box>
          </Box>

          {/* Form Error */}
          {formError && (
            <Typography color="error" align="center" sx={{ mt: 1.5 }}>
              {formError}
            </Typography>
          )}
        </Box>
        <Divider sx={{ mt: 1.5 }} />
        <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button type="button" variant="outlined" color="inherit" size="small" onClick={handleReset} disabled={saving}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="small"
            disabled={saving}
            startIcon={saving ? <CircularProgress size={14} color="inherit" /> : null}
          >
            {mode === "add" || mode === "comp" ? "Save" : "Update"}
          </Button>
        </Box>
      </Box>

      {/* Global Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={1500}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}